import React, { useState } from 'react'
import { Input, Modal, Typography } from 'antd'
import { Participant } from '../../list/types'

const { Text } = Typography

type Props = {
  open: boolean
  participant: Participant | null
  loading: boolean
  onClose: () => void
  onSubmit: (banReason: string) => void
}

export const BanModal: React.FC<Props> = ({
  open,
  participant,
  loading,
  onClose,
  onSubmit,
}) => {
  const [reason, setReason] = useState('')

  const handleCancel = () => {
    setReason('')
    onClose()
  }

  return (
    <Modal
      title="Ban participant"
      open={open}
      onCancel={handleCancel}
      onOk={() => onSubmit(reason)}
      okText="Ban"
      cancelText="Cancel"
      okButtonProps={{ danger: true, disabled: !reason.trim(), loading }}
      afterClose={() => setReason('')}
      destroyOnHidden
    >
      <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
        Participant:{' '}
        <strong>
          {participant?.client.fullName || participant?.client.clientId}
        </strong>
      </Text>
      <Input.TextArea
        placeholder="Ban reason"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        rows={3}
        autoFocus
      />
    </Modal>
  )
}
